import { Component, EventEmitter, Input, Output } from '@angular/core';
import { INotification } from '../../../assets/types/dtoTypes';
import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification-panel.component.html',
  standalone: true,
  imports: [MatIcon, NgIf, NgClass, DatePipe, MatIconButton, NgForOf],
  styleUrl: './notification-panel.component.scss'
})
export class NotificationPanelComponent {
  @Input() notifications: INotification[] = [];

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  closePanel(): void {
    this.close.emit();
  }

  getIcon(type: string): string {
    switch (type) {
      case 'NEW_MESSAGE':        return 'chat_bubble_outline';
      case 'APPLICATION_UPDATED': return 'work_outline';
      default:                    return 'notifications_none';
    }
  }

  getIconClass(type: string): string {
    switch (type) {
      case 'NEW_MESSAGE':        return 'icon-message';
      case 'APPLICATION_UPDATED': return 'icon-app';
      default:                    return 'icon-default';
    }
  }
}